/* jshint esnext: true */

/**
 * The Game scene.
 *
 * This is what powers the game itself.
 */
class SceneGame extends Phaser.Scene {

	constructor() {

		super( { key: 'SceneGame' } );

	}


	// init( data ) {

	// }


	/**
	 * Create the game and set everything up.
	 */
	create() {

		controls.init( this );

		this.cameras.main.setBackgroundColor( gameData.currentBackgroundColor );

		// Setup a new game.
		gameplay.new( this );

		/**
		 * Setup camera zone and player follow.
		 *
		 * The y_camera_offset ensures the player is always nearer the top of
		 * the screen, so that you can see it and avoid fingers that may be
		 * swiping around further down.
		 */
		let y_camera_offset = Math.floor( game.scale.height / -8 );
		this.cameras.main.startFollow( gameCharacter.character, true, 1, 0.8, 0, y_camera_offset );
		this.cameras.main.setDeadzone( 32, Math.floor( game.scale.height / 4 ) );

		console.log( 'camera deadzone offset', y_camera_offset );

	}


	// update( time ) {
	update() {

		gameplay.update( this );

		addons.update( this );

		controls.update();

	}

}